import { useLayoutEffect } from 'react';
import { useThemeStore } from '@/lib/theme.store';

/**
 * ThemeProvider
 *
 * Muss einmalig nahe der Wurzel des App-Baums gerendert werden.
 * Wendet das aktive Theme synchron vor dem ersten Paint an (useLayoutEffect)
 * und re-applied es bei jedem Theme-Wechsel.
 */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const applyTheme = useThemeStore((s) => s.applyTheme);
  // activeThemeId als Abhängigkeit: Effect läuft neu, sobald der User das Theme wechselt.
  const activeThemeId = useThemeStore((s) => s.activeThemeId);

  useLayoutEffect(() => {
    // Synchron vor dem ersten Paint: verhindert FOUC bei Seitenneuladung.
    applyTheme();
  }, [applyTheme, activeThemeId]);

  return <>{children}</>;
}
